/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";
import {  deepClone } from "@/helpers/utils.js";

/* Exports */
// API services that can be invoked on the modules
export const SPEAKERS_SERVICE = {postOccurence, getOccurences, putOccurence, getOccurenceDetails, deleteOccurenceById, putOccurenceStatus};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Occurences";

/* Services */
//Service to create occurences
function postOccurence(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    // Clean url of images
    var body = deepClone(new Object, input);
    body.photos.forEach(photo => {
        if(photo.url) photo.url = photo.url.replace(process.env.VUE_APP_URL_ROOT, '');
    });
    body = JSON.stringify(body);

    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: body
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get paginated occurences
function getOccurences(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}


//Service to update occurences
function putOccurence(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    // Clean url of images
    var body = deepClone(new Object, input);
    body.photos.forEach(photo => {
        if(photo.url) photo.url = photo.url.replace(process.env.VUE_APP_URL_ROOT, '');
    });
    body = JSON.stringify(body);
    
    console.log(body);
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: body
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get occurence details
function getOccurenceDetails(uniqueIdentifier)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, uniqueIdentifier]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to delete occurences
function deleteOccurenceById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'DELETE',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

//Service to update occurence status
function putOccurenceStatus(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "status"]);
   
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}
